import React, { useEffect, useState } from "react";
import { Parents } from "../utils/CartegoryParent";
import {
  AdminUpdateSingleCategory,
  AdminViewSingleCategory,
} from "../utils/Api/ApiCalls.js";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";

const ProductCategoryEdit = () => {
  const [singleData, setSingleData] = useState({});
  const [load, setLoad] = useState(false);
  const { id } = useParams();
  const [formData, setFormData] = useState({
    name: "",
    // slug: "",
    parent: "",
    desc: "",
  });

  const OnHandleChange = (e) => {
    const { value, name } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const FetchingSingleCategory = async () => {
    try {
      const response = await AdminViewSingleCategory(id);
      setSingleData(response.data);
      
    } catch (err) {
    Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };

  useEffect(() => {
    FetchingSingleCategory();
  }, []);

  const UpdateCategory = async () => {
    setLoad(true);
    try {
      const response = await AdminUpdateSingleCategory(id, formData);
      
      setLoad(false);

      Swal.fire({
        title: "Category updated Successfully",
        icon: "success",
      }).then(() => {
        // window.location.reload();
      });
    } catch (err) {
    Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };
  return (
    <section class="content-main">
      <div class="content-header">
        <div>
          <h2 class="content-title card-title">Update Category</h2>
          <p>Edit a category</p>
        </div>
        <div>
          <input
            type="text"
            placeholder="Search Categories"
            class="form-control bg-white"
          />
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  UpdateCategory();
                }}
              >
                <div class="mb-4">
                  <label for="product_name" class="form-label">
                    Name
                  </label>
                  <input
                    required
                    name="name"
                    onChange={OnHandleChange}
                    type="text"
                    placeholder="Type here"
                    class="form-control"
                    id="product_name"
                    value={singleData?.name}
                    // defaultValue={singleData?.name}
                  />
                </div>

                <div class="mb-4">
                  <label class="form-label">Parent</label>
                  <select
                    required
                    name="parent"
                    onChange={OnHandleChange}
                    class="form-select"
                    defaultValue={singleData?.parent}
                  >
                    <option selected disabled>
                      --Select--
                    </option>
                    {Parents?.map((props) => (
                      <option value={props}>{props}</option>
                    ))}
                  </select>
                </div>
                <div class="mb-4">
                  <label class="form-label">Description</label>
                  <textarea
                    required
                    name="desc"
                    onChange={OnHandleChange}
                    placeholder="Type here"
                    class="form-control"
                    defaultValue={singleData?.slug}
                  ></textarea>
                </div>
                {load ? (
                  <div class="d-grid">
                    <button disabled class="btn btn-primary">
                      Loading...
                    </button>
                  </div>
                ) : (
                  <div class="d-grid">
                    <button onClick={UpdateCategory} class="btn btn-primary">
                      Update category
                    </button>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductCategoryEdit;
